import { CreateBankAccountDto, UpdateBankAccountDto } from '@/api/bank-accounts';
import generateId from '@/utils/random';
import { BankAccount, DirectDebitMandate } from '@/api/payment-orders';

function createBankAccount(
  name: string,
  isPayable: boolean,
  iban: string | null = null,
  synesisCode: string | null = null,
  directDebitMandate: DirectDebitMandate | null = null,
  creditorSchemeId: string | null = null,
): BankAccount {
  const id = generateId();

  return {
    id,
    name,
    isPayable,
    iban,
    synesisCode,
    directDebitMandate,
    creditorSchemeId,
  };
}

let bankAccounts: BankAccount[] = [
  createBankAccount('Petračić-projekt d.o.o.', true, 'HR9024000081110178472'),
  createBankAccount('Luščić 8B', true, 'HR4524000081310182903'),
  createBankAccount('Banija 13', true),
  createBankAccount('Bartola Kašića 3', true, 'HR8224000081310181267'),
  createBankAccount('Domobranska 3', true, 'HR1124000081310181187', null, null, '1234567'),
  createBankAccount('Domobranska 16A', true, 'HR2124000081310181007'),
  createBankAccount('HEP Elektra d.o.o.', false, 'HR5524020061500273691'),
  createBankAccount('Johanna Doette', false, 'HR3325000091748116297', '1234567', null),
  createBankAccount('John Doe', true, null, '321'),
];

export default {
  get() {
    return { data: bankAccounts };
  },

  post({
    name, iban, isPayable, synesisCode,
  }: CreateBankAccountDto) {
    const bankAccount = createBankAccount(name, isPayable, iban, synesisCode);

    bankAccounts.push(bankAccount);

    return { data: bankAccount };
  },

  put(id: string, bankAccountdto: UpdateBankAccountDto) {
    const account = bankAccounts.find((bankAccount) => bankAccount.id === id);

    if (!account) {
      throw new Error(`Can't find bank account with id ${id}`);
    }

    const data = Object.assign(account, bankAccountdto);

    return { data };
  },

  delete(id: string) {
    bankAccounts = bankAccounts.filter((bankAccount) => bankAccount.id !== id);
  },
};
